import { render } from "./FeaturesSetting.vue?vue&type=template&id=339df530&ts=true"
import script from "./FeaturesSetting.vue?vue&type=script&lang=ts"
export * from "./FeaturesSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__